var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page--error_with_code"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.$te(`error.${_vm.$route.params.code}`) ? _vm.$t(`error.${_vm.$route.params.code}`) : _vm.$t(`error.generic`)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }